export default "__VITE_ASSET__WwZLJ4CM__"